import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW2100Component } from './kymw2100.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetCatalogProgressOfMediumService } from './api-services/get-catalog-progress-of-medium.service';
import { GetOrderNumListService } from './api-services/get-order-num-list.service';
import { UpdateIndiscriminatelyOrderNumService } from './api-services/update-indiscriminately-order-num.service';
import { UpdateIndividuallyOrderNumService } from './api-services/update-individually-order-num.service';
import { FormsModule } from '@angular/forms';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';




/**
 * 注文コード設定画面 モジュール設定クラス
 *
 * @export KYMW2100Module
 * @class KYMW2100Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    FormsModule,
  ],
  declarations: [
    KYMW2100Component,
  ],
  providers: [
    GetCatalogProgressOfMediumService,
    GetOrderNumListService,
    UpdateIndiscriminatelyOrderNumService,
    UpdateIndividuallyOrderNumService,
    CatalogLockService,
  ],
})

export class KYMW2100Module { }
